import { RequestBasePageId, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBasePage, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { AuthPerm } from "../auth-perm";

export class RequestPermission extends RequestBasePageId {
}

export class RequestPermissionSet extends RequestBaseSet<AuthPerm>
{
}

export class ResponsePermission extends ResponseBasePage<AuthPerm> {

}


export class ResponsePermissionSet extends ResponseBaseSet<AuthPerm>{

}
